import { Fancybox } from "@fancyapps/ui";
import "../_plugins/@master/css";
import "./modules/Header";
import "./modules/Slider";
import "./modules/Accordion";
import "./modules/BackToTop";
import "./modules/ExpandContent";
import "./modules/Infographic";
import "./modules/Major";

var lazyLoadInstance = new LazyLoad({
	// Your custom settings go here
});

window.lazyLoadInstance = lazyLoadInstance;

Fancybox.bind("[data-fancybox]", {
	// Your custom options
});

$(function () {
	$(document).on("click", ".load-more", function (e) {
		e.preventDefault();
		let hrefNextPage = $(this).attr("href");
		let $this = $(this);
		$.ajax({
			url: hrefNextPage,
			success: function (data) {
				$(".ajax-response").append(
					$(data).find(".ajax-response").html()
				);
				$this.remove();
				$(".ajax-response-pager").html(
					$(data).find(".ajax-response-pager").html()
				);
			},
		});
	});

	$(".achievement-filter select").on("change", function () {
		let filter = $(this).val();
		$(".milestone-container").each(function () {
			let $id = $(this).attr("id");
			if (filter == "all") {
				$(this).addClass("active");
			} else if ($id == filter) {
				$(this).addClass("active");
			} else {
				$(this).removeClass("active");
			}
		});
	});
});
